import React from 'react'
import ImageWithBasePath from '../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import { all_routes } from '../../router/all_routes'

interface BannerProps {
    apiValues: any;
}



const Aboutsection: React.FC<BannerProps> = ({ apiValues }) => {

    const route = all_routes;
    return (
        <>
            {/* About Section */}
            <section className="about-section">
                <div className="container">
                    <div className="row align-items-center row-gap-4">
                        <div
                            className="col-lg-7 wow fadeInLeft order-lg-1 order-xs-2 order-sm-2"

                        >
                            <div className="section-header">
                                <span className="fw-medium text-secondary fs-18 fw-bold mb-2 d-inline-block">
                                    {apiValues?.headingText}
                                </span>
                                <h2 className="mb-0">
                                    {apiValues?.headingDescription}
                                </h2>
                            </div>
                            <div className="about-content">
                                <p>
                                    {apiValues?.headingMiniDescription}
                                </p>
                                <div className="about-img">
                                    <div className="row row-gap-4">
                                        {

                                            (Array.isArray(apiValues?.headingCards) ? apiValues?.headingCards : []).map((univ: any, index: number) => {

                                                return (
                                                    <div className="col-md-4">
                                                        <ImageWithBasePath
                                                            source={univ?.imageUrl}
                                                            className="img-fluid"
                                                            alt="img"
                                                        />
                                                    </div>
                                                )
                                            }) || []
                                        }

                                    </div>
                                </div>
                                <Link to={route.Unlock} className="btn btn-danger btn-xl mt-3">
                                    {apiValues?.buttonText}
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-5 order-lg-2 order-xs-1 order-sm-1">
                            <div className="stylist-gallery">
                                <div className="row row-gap-4">
                                    {

                                        (Array.isArray(apiValues?.rightSideImages) ? apiValues?.rightSideImages : []).map((item: any, index: number) => {

                                            return (
                                                <div
                                                    className="col-lg-6 col-md-6 col-sm-12 col-12"

                                                >

                                                    <div className="flex flex-col items-center justify-center border rounded-md p-4 bg-white w-full max-w-sm">
                                                        <div className="p-3">
                                                            <ImageWithBasePath source={item?.imageUrl} alt="Img" />
                                                        </div>
                                                        <div className="text-center mt-2">
                                                            <p className="mb-0">{item?.title}</p>
                                                        </div>
                                                    </div>



                                                </div>

                                            )
                                        }) || []
                                    }

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </section>
        </>

    )
}

export default Aboutsection
